<template>
  <div class="sidebar-navigation">
     <!-- Mobile top bar -->
     <header class="sticky top-0 z-40 flex justify-between items-center gap-x-6 bg-primary-800 px-4 py-4 shadow-sm sm:px-6 lg:hidden mt-[54px]">
      <button type="button" class="-m-2.5 p-2.5 text-slate-400 lg:hidden" @click="mobileSidebarOpen = true">
        <span class="sr-only">Open sidebar</span>
        <span class="i-heroicons-bars-2 size-6 text-white" aria-hidden="true" />
      </button>
      <!-- <div class="flex-1 text-sm font-semibold leading-6 text-white">
        <NavLogo />
      </div> -->
      <UserNavMenu v-if="isAuthenticated" position="bottom-right" variant="default" />
    </header>

    <!-- Mobile sidebar -->
    <TransitionRoot as="template" :show="mobileSidebarOpen">
      <Dialog class="relative z-50 lg:hidden" @close="mobileSidebarOpen = false">
        <TransitionChild as="template" enter="transition-opacity ease-linear duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="transition-opacity ease-linear duration-300" leave-from="opacity-100" leave-to="opacity-0">
          <div class="fixed inset-0 bg-black/50 lg:hidden" />
        </TransitionChild>

        <div class="fixed inset-0 flex lg:hidden">
          <TransitionChild as="template" enter="transition ease-in-out duration-300 transform" enter-from="-translate-x-full" enter-to="translate-x-0" leave="transition ease-in-out duration-300 transform" leave-from="translate-x-0" leave-to="-translate-x-full">
            <DialogPanel class="relative mr-16 flex w-full max-w-xs flex-1">
              <div class="duration-300 ease-in-out fixed inset-y-0 max-w-80 p-1.5 transition w-full">
                <div class="flex grow flex-col h-full overflow-y-auto bg-primary-800 ring-1 ring-secondary/5 rounded-xl">
                  <div class="pt-4 px-4" @click="mobileSidebarOpen = false">
                    <button class="pt-2 rounded-lg">
                      <span class="sr-only">Close sidebar</span>
                      <span class="i-heroicons-x-mark h-6 w-6 text-slate-500" aria-hidden="true" />
                    </button>
                  </div>

                  <div class="flex gap-3 p-4 border-b border-secondary/5">
                    <div class="flex gap-3 p-2 justify-between items-center w-full">
                      <NavLogo :icon-logo="true" />
                      <span class="text-slate-400 text-xs">v.{{ packageJson.version }}</span>
                    </div>
                  </div>

                  <NavMenu v-if="isAuthenticated && isEmployee" context="admin" class="py-4" />
                  <NavMenu v-else-if="isAuthenticated && isCustomer" context="customer" :customer-id="customerId" class="pb-4" />
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>

    <!-- Static sidebar for desktop -->
    <div :class="['hidden lg:fixed lg:flex inset-y-0 z-50 w-64 flex-col']" class="lg:mt-[54px]">
      <div :class="['flex grow flex-col gap-y-5 overflow-y-auto overflow-x-visible bg-primary-800']">
        <div class="flex gap-3 p-4 border-b border-secondary/5">
          <div class="flex gap-3 p-2 justify-between items-center w-full">
            <NavLogo :icon-logo="false" />
            <span class="text-slate-400 text-xs">v.{{ packageJson.version }}</span>
          </div>
        </div>
        <NavMenu v-if="isAuthenticated && isEmployee" context="admin"  />
        <NavMenu v-else-if="isAuthenticated && isCustomer && customerId" context="customer" :customer-id="customerId" />
        <UserNavMenu v-if="isAuthenticated" class="p-4 border-t border-secondary/5" position="top-left" variant="secondary" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import {
  Dialog,
  DialogPanel,
  TransitionChild,
  TransitionRoot,
} from '@headlessui/vue'
import NavMenu from '@/components/TheNavMenu.vue'
import { useAuth } from '@/composables/useAuth'
import CustomerService from '@/services/CustomerService'
import NavLogo from '@/components/TheNavLogo.vue'
import UserNavMenu from '@/components/TheUserNavMenu.vue'
import * as packageJson from '../../package.json'
import { useRouter } from 'vue-router'


const { currentUser, isAuthenticated, isEmployee, isCustomer } = useAuth()
const router = useRouter()
const mobileSidebarOpen = ref(false)
const customerId = ref('')

router.afterEach(() => {
  mobileSidebarOpen.value = false
})

onMounted(async () => {
  if (isCustomer) {
    const customerService = new CustomerService()
    const customer = await customerService.find_by('accountId', '==', currentUser.value.id)
    customerId.value = customer.shift()?.id
  }
})
</script>
